import styled from 'styled-components'
import noop from 'lodash/noop'
import Slider from 'react-slick'

import { breakpoints, colors, fontWeights } from '@/styles'
import CdnImage from '@/components/cdn-image'

import prevArrow from './arrow-left.svg'
import nextArrow from './arrow-right.svg'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const SliderViewButton = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  height: 35px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.white};
  border-radius: 2px;
  box-shadow: 1px 2px 4px 0 rgba(0, 0, 0, 0.5);
  font-size: 14px;
  color: ${colors.regular};
  font-weight: ${fontWeights.regular};
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;

  @media (max-width: ${breakpoints.phoneMax}) {
    display: none;
  }
`

const SliderWrapper = styled.div`
  position: relative;
  height: 100%;
  background-color: #eee;
`

const PhotoWrapper = styled.div`
  position: relative;
`

const ArrowStyle = styled.button`
  z-index: 2;
  top: 55%;
  position: absolute;
  height: 32px;
  width: 32px;
  background-size: cover;
  transform: translateY(-50%);
  outline: none;
  padding: 0;
`

const PrevArrowStyled = styled(ArrowStyle)`
  left: 8px;
  background: url(${prevArrow}) no-repeat center;
  background-size: cover;
`
const NextArrowStyled = styled(ArrowStyle)`
  right: 8px;
  background: url(${nextArrow}) no-repeat center;
  background-size: cover;
`

const withPropagationDisabled =
  callback =>
  (e, ...rest) => {
    e.stopPropagation()
    e.preventDefault()

    callback(e, ...rest)
  }

const PrevArrow = ({ onClick }) => (
  <PrevArrowStyled
    onClick={withPropagationDisabled(onClick)}
    className="prev"
    title="Previous Photo"
    aria-label="Previous Photo"
  />
)

const NextArrow = ({ onClick }) => (
  <NextArrowStyled
    onClick={withPropagationDisabled(onClick)}
    className="next"
    title="Next Photo"
    aria-label="Next Photo"
  />
)

const PhotoSlider = ({
  images,
  buttonText = '',
  altText = '',
  onMouseDown,
  openImage = noop,
  placeholder = 'blur',
  sizes = '100vw',
  ...rest
}) => {
  const settings = {
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />
  }

  return (
    <Slider {...settings} {...rest}>
      {images.map((image, index) => (
        <SliderWrapper key={index}>
          {!!buttonText && (
            <SliderViewButton className="photo-carousel-view-button">
              {buttonText}
            </SliderViewButton>
          )}
          <PhotoWrapper
            className="photo-carousel-image"
            onClick={openImage(index)}
            onMouseDown={onMouseDown}
          >
            <CdnImage
              src={image}
              placeholder={placeholder}
              layout="fill"
              sizes={sizes}
              objectFit="cover"
              alt={`${altText ? `${altText} ${index + 1}` : ''}`}
            />
          </PhotoWrapper>
        </SliderWrapper>
      ))}
    </Slider>
  )
}

export default PhotoSlider
